import React from 'react';

const AboutMePage = () => {
    return (
        <div>
            <h1>About Me</h1>
        </div>
    );
};

export default AboutMePage;
